import { useTranslation } from 'react-i18next';
import React from "react";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { useStockDetailedModel } from "../stockDetailedModel";
import { DataTable } from "./DataTable";
import { formatNum } from '@/erp_subpackage/utils/util';
import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, Tooltip } from "antd";

export const DataBox = () => {
    const { t } = useTranslation();
    const { descTotal, searchParam, shopId, exportList, setShiftShelfModal, setRecordsVisible, setSectionShelfModal, rowsDescTotal, selectedRowKeys } = useStockDetailedModel();

    const shelfMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={() => setShiftShelfModal(true)}> {t(`stock.view.DataBox.全部转移`)}</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={() => setSectionShelfModal(true)}> {t(`stock.view.DataBox.部分转移`)}</span>
                </Menu.Item>
            </Menu>
        )
    }

    const action = <>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => exportList()}
        > {t(`stock.view.DataBox.导出`)}</Button>
        <Dropdown overlay={shelfMenu}>
            <Button
                className="mr-5 btn-item"
                type="link"
                shape="round"
            >{t(`stock.view.DataBox.货位转移`)}<DownOutlined /></Button>
        </Dropdown>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => setRecordsVisible(true)}
            disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
        >{t(`stock.view.DataBox.移库记录`)}</Button>
    </>;

    const desc = [
        {
            label: t(`stock.view.DataBox.库存成本`),
            value: !selectedRowKeys.length ? `￥${formatNum(descTotal?.stockAmount)}` : `￥${formatNum(rowsDescTotal.stockAmount)}`,
            color: "red"
        },
        {
            label: t(`stock.view.DataBox.库存数量`),
            value: !selectedRowKeys.length ? descTotal?.stockNum : rowsDescTotal.stockNum,
            color: "red"
        },
    ]

    return (
        <YhBox title={t(`stock.view.DataBox.库存明细列表`)} action={action} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}

